/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yummy_Sunny_Liger_PatInputs */

const fr_yummy_sunny_liger_pat = /** @type {(inputs: Yummy_Sunny_Liger_PatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public ?`)
};

/**

* @param {Yummy_Sunny_Liger_PatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const yummy_sunny_liger_pat = /** @type {((inputs?: Yummy_Sunny_Liger_PatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yummy_Sunny_Liger_PatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_yummy_sunny_liger_pat(inputs)
});